import { GROUP_ID } from "@/constant/group";
import { moimApi } from "./base";

export const miniAppAPI = moimApi("https://vingle.network/api/v3/miniapp");
export const moimAPI = moimApi("https://11plus.vingle.network/api");
export const communitAPI = moimApi("https://community-service.moim.mobi", {
  "x-can-user-locale": window.navigator.language,
  "x-can-community-id": GROUP_ID,
  "x-can-origin-community-id": GROUP_ID,
});
